export default __webpack_public_path__ + "static/media/img_baseRattle_green.bf2700b3.jpg";